import axios from "axios";
import objectToFormData from "../utils/objectToFormData";
import { API } from "../constants";
import { apiUrl } from "./lt-api";

axios.defaults.baseURL = API;

const defaultHeaders = {
  crossDomain: true,
  headers: {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
    withCredentials: true
  }
};

const getConfigWithToken = (method = "get", extraConfig = {}) => {
  const token = JSON.parse(localStorage.getItem('token'));
  return {
    ...defaultHeaders,
    method,
    headers: {
      ...defaultHeaders.headers,
      Authorization: token ? `Bearer ${token}` : undefined,
    },
    ...extraConfig
  };
};

export function getProductData(id, product_id) {
  return axios({
    ...getConfigWithToken("get"),
    url: `${apiUrl}etl/scrapers/${id}/products/${product_id}`
  });
}

export function getFilterData() {
  return axios({
    ...getConfigWithToken("get"),
    url: `${apiUrl}etl/scrapers/filter_options`
  });
}

export function getProductDataClone(id) {
  return axios({
    ...getConfigWithToken("get"),
    url: `${apiUrl}etl/scrapers/64/products/${id}/clone`
  });
}

export function getProductOptionsData() {
  return axios({
    ...getConfigWithToken("get"),
    url: `${apiUrl}etl/scrapers/64/product_options`
  });
}

export function getFurnitureData(id) {
  return axios({
    ...getConfigWithToken("get"),
    url: `${API}/furniture/${id}`
  });
}

export function updateProductData(id, payload) {
  const formData = objectToFormData(payload);
  return axios({
    ...getConfigWithToken("PUT"),
    url: `${apiUrl}etl/scrapers/64/products/${id}`,
    data: formData
  });
}
